module.exports = __webpack_public_path__ + "static/media/Chili Costume Fan.d68f2ec2.jpg";